"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["data_space_id"];
const _hoisted_2 = {
    key: 0,
    class: "board-space-text"
};
const _hoisted_3 = {
    key: 2,
    class: "board-space-coords"
};
const _hoisted_4 = ["data_log_highlight_id"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_board_space_tile = (0, vue_1.resolveComponent)("board-space-tile");
    const _component_bonus = (0, vue_1.resolveComponent)("bonus");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.mainClass),
        data_space_id: _ctx.space.id
    }, [
        (0, vue_1.createVNode)(_component_board_space_tile, {
            space: _ctx.space,
            aresExtension: false,
            tileView: _ctx.tileView
        }, null, 8, ["space", "tileView"]),
        (_ctx.text)
            ? (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.text), 1)
            ])), [
                [_directive_i18n]
            ])
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.space.tileType === undefined || _ctx.tileView === 'hide')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_bonus, {
                key: 1,
                bonus: _ctx.space.bonus
            }, null, 8, ["bonus"]))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.tileView === 'coords')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.getSpaceName(_ctx.space.id)), 1))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.space.color !== undefined && _ctx.tileView === 'show')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 3,
                class: (0, vue_1.normalizeClass)(_ctx.playerColorCss)
            }, null, 2))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.space.coOwner !== undefined && _ctx.tileView === 'show')
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 4,
                class: (0, vue_1.normalizeClass)(_ctx.coOwnerColorCss)
            }, null, 2))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", {
            class: "board-log-highlight",
            data_log_highlight_id: _ctx.space.id
        }, null, 8, _hoisted_4)
    ], 10, _hoisted_1));
}
